import { getRequest, postRequest, uploadEncodedFileLarge } from "NetworkCall";
import { INSTANCE_URL, BASE_IMAGES_URL } from "Constants";

export var SUPPORTCHAT_THREAD = "SUPPORTCHAT_THREAD";
export var SUPPORTCHAT_DETAILS = "SUPPORTCHAT_DETAILS";
export var SUPPORTCHAT_USERDETAILS = "SUPPORTCHAT_USERDETAILS";

/******  Thread List (DISTINCT USER)  ******/

const fetchSupportChat = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/supportchat`;
  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "thread",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;
        dispatch({ type: SUPPORTCHAT_THREAD, data: data.resource });
        callback({ error: 0, data: "" });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
};

/**** Get Support Chat Details With Email ****/
const fetchSupportChatDetails = (session, email, callback) => {
  var filter = encodeURI(
    `fields=*&order=unixtimestamp ASC&filter=((eventid=${session.eventid})AND(useremail=${email}))&admin=1&eventid=${session.eventid}&useremail=${email}`
  );

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/supportchat?${filter}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {

        var data = response;
        dispatch({ type: SUPPORTCHAT_DETAILS, data: data.resource });
        callback({ error: 0, data: "" });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
};

/**** Sent Messages ****/
const sentMessage = (session, values, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/supportchat/`;

  return (dispatch) => {
    postRequest(
      url,
      {
        resource: [values],
      },
      session,
      dispatch,
      (response) => {
        callback({ error: 0, data: "" });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
};

const uploadMediaLarge = (session, uploadFiles, callback) => {
  var filecontent = uploadFiles.media;
  var filename = uploadFiles.name;
  var filetype = uploadFiles.type;
  var eventid = session.eventid;

  const dataMedia = new FormData();
  if (filetype == "video") {
    var blob = new Blob([filecontent], { type: "video/mp4" });
  } else if (filetype == "audio") {
    var blob = new Blob([filecontent], { type: "audio/mp3" });
  } else if (filetype == "image") {
    var blob = new Blob([filecontent], { type: "image/jpg" });
  } else {
    var blob = new Blob([filecontent], { type: filetype });
  }

  dataMedia.append("files", blob, filename);

  return (dispatch) => {
    uploadEncodedFileLarge(
      `${BASE_IMAGES_URL}/eventify/${eventid}/supportchat/`,
      session,
      dataMedia,
      dispatch,
      (data) => {
        callback({ success: 1, message: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
};

/**** Get User Details [With Event Id & email] ****/
const fetchUserDetailsWithEmail = (session, email, callback) => {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&filter=((eventid=${session.eventid})AND(email=${email}))`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: SUPPORTCHAT_USERDETAILS,
          data: response.resource[0] ? response.resource[0] : {},
        });
        callback({ error: 0, data: "" });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
};

export {
  fetchSupportChat,
  fetchSupportChatDetails,
  sentMessage,
  uploadMediaLarge,
  fetchUserDetailsWithEmail,
};
